export default {
  LOGIN: '/auth/login',
  CALL: '/call/event'
}
